import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '~/generated/portal-api';

export function createRegistrationApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		checkEmail(request: components['schemas']['EmailViewModel']) {
			return client.POST('/api/registration/email-check', { body: request });
		},

		checkPassword(request: components['schemas']['PasswordViewModel']) {
			return client.POST('/api/registration/password-check', { body: request });
		},

		createRegistration(request: components['schemas']['RegisterRequestViewModel']) {
			return client.POST('/api/registration/create', { body: request });
		},

		offlineActivation(request: components['schemas']['ActivateOfflineAccountRequestViewModel']) {
			return client.POST('/api/account-activatie', { body: request });
		},
	};
}
